import React from "react"
import Button from "@material-ui/core/Button"
import Dialog from "@material-ui/core/Dialog"
import DialogContent from "@material-ui/core/DialogContent"

import SearchIcon from "@material-ui/icons/Search"
import SearchBar from "material-ui-search-bar"

import { navigate } from "gatsby"

import "./searchBar.scss"

export default function SearchBarComponent(props) {
  const [open, setOpen] = React.useState(false)
  const [value, setValue] = React.useState("")
  const [isBeingSearched, setIsBeingSearched] = React.useState(false)

  const handleClickOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <div>
      <div className="search-icon" role="presentation" onClick={handleClickOpen}>
        <SearchIcon style={{ color: props.color }} />
      </div>
      <Dialog
        className="searchbar-dialog"
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogContent>
          <SearchBar
            value={value}
            placeholder="Keresés..."
            onChange={(newValue) => {
              setIsBeingSearched(false)
              setValue(newValue)
              setIsBeingSearched(true)
            }}
            onCancelSearch={() => {
              setIsBeingSearched(false)
              setValue("")
            }}
            onRequestSearch={() => console.log(value)}
          />
          {isBeingSearched ? (
            <Button
              className="search-i"
              onClick={() => navigate(`/search?q=${value}`)}
            >
              <SearchIcon />
            </Button>
          ) : null}
        </DialogContent>
      </Dialog>
    </div>
  )
}
